// Static UI copy per locale. Data-driven text comes from the API via pick().
export const STRINGS = {
  fr: {
    localeName: 'Français',
    brand: 'Emplois',
    brandSuffix: 'LampTwist',
    metaTitleHome: 'Emplois · LampTwist',
    metaDescHome:
      "Découvrez les offres d'emploi du groupe LampTwist — Calum, LampTwist et nos autres enseignes.",
    heroEyebrow: 'Rejoignez-nous',
    heroTitle: 'Construisons quelque chose de bon, ensemble.',
    heroSubtitle:
      "Toutes les offres d'emploi du groupe LampTwist, réunies au même endroit.",
    openingsCount: (n) => `${n} ${n > 1 ? 'postes ouverts' : 'poste ouvert'}`,
    noOpenings: 'Aucune offre ouverte pour le moment.',
    noOpeningsHint: 'Revenez bientôt — de nouvelles opportunités arrivent régulièrement.',
    viewOffer: "Voir l'offre",
    loading: 'Chargement…',
    errorTitle: 'Oups.',
    errorBody: "Impossible de charger les offres pour le moment.",
    retry: 'Réessayer',
    backToList: 'Toutes les offres',
    notFoundTitle: 'Offre introuvable',
    notFoundBody: "Cette offre n'existe plus ou a été clôturée.",
    sectionProfile: 'Profil recherché',
    sectionOffer: 'Ce que nous offrons',
    aboutOrg: (name) => `À propos de ${name}`,
    apply: 'Postuler',
    applyOnline: 'Postuler en ligne',
    applyByEmail: 'Postuler par email',
    applySubject: (title) => `Candidature · ${title}`,
    applyBody: (title) =>
      `Bonjour,\n\nJe souhaite poser ma candidature pour le poste « ${title} ».\n\n`,
    contact: 'Personne de contact',
    reference: 'Référence',
    closesOn: (d) => `Candidatures jusqu'au ${d}`,
    openingsSeats: (n) => `${n} ${n > 1 ? 'postes' : 'poste'}`,
    labelDepartment: 'Département',
    labelSchedule: 'Horaire',
    labelSalary: 'Rémunération',
    labelLocation: 'Lieu',
    visitWebsite: 'Site web',
    spontaneousEyebrow: 'Candidature spontanée',
    spontaneousTitle: 'Aucune offre ne vous correspond ?',
    spontaneousBody:
      "Envoyez-nous une candidature spontanée, nous gardons votre profil de côté pour nos prochaines opportunités.",
    spontaneousCta: 'Envoyer une candidature spontanée',
    spontaneousSubject: 'Candidature spontanée · Groupe LampTwist',
    spontaneousMailBody:
      "Bonjour,\n\nJe vous envoie ma candidature spontanée. Vous trouverez mon CV en pièce jointe.\n\n",
    mailGmail: 'Gmail',
    mailOutlook: 'Outlook',
    mailEmailApp: 'Application e-mail',
    mailCopy: "Copier l'adresse",
    mailCopied: 'Adresse copiée',
    footerTagline: 'Le groupe LampTwist — Calum, LampTwist & co.',
    footerRights: 'Tous droits réservés.',
  },
  nl: {
    localeName: 'Nederlands',
    brand: 'Jobs',
    brandSuffix: 'LampTwist',
    metaTitleHome: 'Jobs · LampTwist',
    metaDescHome:
      'Ontdek de vacatures van de LampTwist-groep — Calum, LampTwist en onze andere merken.',
    heroEyebrow: 'Kom bij ons werken',
    heroTitle: 'Laten we samen iets goeds bouwen.',
    heroSubtitle: 'Alle vacatures van de LampTwist-groep, op één plek.',
    openingsCount: (n) => `${n} ${n > 1 ? 'openstaande vacatures' : 'openstaande vacature'}`,
    noOpenings: 'Momenteel geen openstaande vacatures.',
    noOpeningsHint: 'Kom binnenkort terug — er komen regelmatig nieuwe kansen bij.',
    viewOffer: 'Bekijk vacature',
    loading: 'Laden…',
    errorTitle: 'Oeps.',
    errorBody: 'De vacatures konden niet worden geladen.',
    retry: 'Opnieuw proberen',
    backToList: 'Alle vacatures',
    notFoundTitle: 'Vacature niet gevonden',
    notFoundBody: 'Deze vacature bestaat niet meer of is afgesloten.',
    sectionProfile: 'Gezocht profiel',
    sectionOffer: 'Wat wij bieden',
    aboutOrg: (name) => `Over ${name}`,
    apply: 'Solliciteren',
    applyOnline: 'Online solliciteren',
    applyByEmail: 'Solliciteer via e-mail',
    applySubject: (title) => `Sollicitatie · ${title}`,
    applyBody: (title) =>
      `Beste,\n\nIk wil graag solliciteren voor de functie "${title}".\n\n`,
    contact: 'Contactpersoon',
    reference: 'Referentie',
    closesOn: (d) => `Solliciteren tot ${d}`,
    openingsSeats: (n) => `${n} ${n > 1 ? 'plaatsen' : 'plaats'}`,
    labelDepartment: 'Afdeling',
    labelSchedule: 'Uurrooster',
    labelSalary: 'Verloning',
    labelLocation: 'Locatie',
    visitWebsite: 'Website',
    spontaneousEyebrow: 'Spontane sollicitatie',
    spontaneousTitle: 'Geen geschikte vacature?',
    spontaneousBody:
      'Stuur ons een spontane sollicitatie, we houden je profiel bij voor toekomstige kansen.',
    spontaneousCta: 'Stuur een spontane sollicitatie',
    spontaneousSubject: 'Spontane sollicitatie · LampTwist-groep',
    spontaneousMailBody:
      'Beste,\n\nHierbij stuur ik mijn spontane sollicitatie. Mijn cv vind je in bijlage.\n\n',
    mailGmail: 'Gmail',
    mailOutlook: 'Outlook',
    mailEmailApp: 'E-mailapp',
    mailCopy: 'Adres kopiëren',
    mailCopied: 'Adres gekopieerd',
    footerTagline: 'De LampTwist-groep — Calum, LampTwist & co.',
    footerRights: 'Alle rechten voorbehouden.',
  },
  en: {
    localeName: 'English',
    brand: 'Jobs',
    brandSuffix: 'LampTwist',
    metaTitleHome: 'Jobs · LampTwist',
    metaDescHome:
      'Explore open roles across the LampTwist group — Calum, LampTwist and our other brands.',
    heroEyebrow: 'Join the team',
    heroTitle: "Let's build something good, together.",
    heroSubtitle: 'Every open role across the LampTwist group, in one place.',
    openingsCount: (n) => `${n} open ${n > 1 ? 'roles' : 'role'}`,
    noOpenings: 'No open roles at the moment.',
    noOpeningsHint: 'Check back soon — new opportunities open up regularly.',
    viewOffer: 'View role',
    loading: 'Loading…',
    errorTitle: 'Oops.',
    errorBody: "We couldn't load the roles right now.",
    retry: 'Try again',
    backToList: 'All roles',
    notFoundTitle: 'Role not found',
    notFoundBody: 'This role no longer exists or has been closed.',
    sectionProfile: 'Who we’re looking for',
    sectionOffer: 'What we offer',
    aboutOrg: (name) => `About ${name}`,
    apply: 'Apply',
    applyOnline: 'Apply online',
    applyByEmail: 'Apply by email',
    applySubject: (title) => `Application · ${title}`,
    applyBody: (title) =>
      `Hello,\n\nI'd like to apply for the "${title}" role.\n\n`,
    contact: 'Contact person',
    reference: 'Reference',
    closesOn: (d) => `Apply by ${d}`,
    openingsSeats: (n) => `${n} ${n > 1 ? 'openings' : 'opening'}`,
    labelDepartment: 'Department',
    labelSchedule: 'Schedule',
    labelSalary: 'Compensation',
    labelLocation: 'Location',
    visitWebsite: 'Website',
    spontaneousEyebrow: 'Open application',
    spontaneousTitle: 'No role that fits?',
    spontaneousBody:
      "Send us an open application, we'll keep your profile on file for future openings.",
    spontaneousCta: 'Send an open application',
    spontaneousSubject: 'Open application · LampTwist group',
    spontaneousMailBody:
      "Hello,\n\nI'd like to send you an open application. My CV is attached.\n\n",
    mailGmail: 'Gmail',
    mailOutlook: 'Outlook',
    mailEmailApp: 'Email app',
    mailCopy: 'Copy address',
    mailCopied: 'Address copied',
    footerTagline: 'The LampTwist group — Calum, LampTwist & co.',
    footerRights: 'All rights reserved.',
  },
};

// Maps a UI locale to a BCP-47 tag for Intl date formatting.
export const DATE_LOCALE = { fr: 'fr-BE', nl: 'nl-BE', en: 'en-GB' };
